export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5260.5f9fbc64.jpg";